module.exports = __webpack_public_path__ + "static/media/25.adabb371.jpg";